module.exports = __webpack_public_path__ + "media/sfx_enter_1.d6546e45.wav";